<script lang="ts">
	import { page } from '$app/stores';
	import NavActions from './NavActions.svelte';
	import HomeSettingsModal from './HomeSettingsModal.svelte';
	import { btn } from '$lib/actions';
	import LogoIcon from './LogoIcon.svelte';
	import LogoFull from './LogoFull.svelte';

	let settingsOpen = $state(false);
</script>

<nav style="top: 0; height: calc(3.25rem + env(safe-area-inset-top)); padding-top: env(safe-area-inset-top)" class="game-card fixed right-0 left-0 z-20 w-full overflow-hidden bg-black">
	<div class="nav-inner absolute right-0 bottom-0 left-0 h-13 overflow-hidden">
	<div class="pixel-frame absolute inset-0 bg-(--top-nav-frame-outer)"></div>
	<div class="pixel-frame absolute inset-0.5 bg-(--top-nav-frame-highlight)"></div>
	<div class="pixel-frame absolute inset-1.5 bg-(--top-nav-frame-shadow)"></div>
	<div class="pixel-frame absolute inset-2 bg-(--top-nav-frame-fill)"></div>
	<div class="pixel-frame absolute inset-2.5 bg-(--top-nav-frame-shadow)"></div>
	<div class="relative flex h-full items-center {$page.url.pathname === '/' ? 'justify-center' : ''} px-2">
		<a href="/" use:btn class="flex items-center">
			<span class="sm:hidden">
				{#if $page.url.pathname === '/'}
					<LogoFull size={36} text="GAMES" />
				{:else}
					<LogoIcon size={36} />
				{/if}
			</span>
			<span class="hidden sm:block"><LogoFull size={36} /></span>
		</a>
		{#if $page.url.pathname !== '/'}
			<div class="absolute top-0 right-2 bottom-0 flex items-center">
				<NavActions />
			</div>
		{/if}
	</div>
	</div>
</nav>

<HomeSettingsModal open={settingsOpen} onclose={() => (settingsOpen = false)} />
